export default "__VITE_ASSET__2fbb6a76__"